import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { SecurityWebComponentPanelComponent } from './lib/security-web-component-panel.component'
import { SecurityWebComponentKey } from './panel-key'

export * from './lib/security-web-component.module'
export * from './panel-key'

export const SecurityWebComponentPanelConfig: PanelConfig = {
  key: SecurityWebComponentKey,
  title: 'Security Detail',
  description:
    'View details for a selected security, including required fields and contract details.',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: SecurityWebComponentPanelComponent,
  accessPermission: 'accessSecurityDetailPanel',
}
